import { render, staticRenderFns } from "./ViewFormAcessoPessoa.vue?vue&type=template&id=2c4d1efa"
import script from "./ViewFormAcessoPessoa.vue?vue&type=script&lang=js"
export * from "./ViewFormAcessoPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports